import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to image CDN FIRST for faster resource discovery
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image (LCP element) — highest priority, before any scripts
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.type = 'image/webp';
link.setAttribute('fetchpriority', 'high');
link.setAttribute('imagesizes', '(max-width: 768px) 100vw, 768px');
link.href = 'https://cdn.magicpatterns.com/uploads/vN4PmtBaiFEccxLMF1kWvR/ChatGPT_Image_25_jun_2026,_15_41_14.webp';
document.head.appendChild(link);
// Render app immediately
render(<App data-id="element-320" />, document.getElementById('root'));
// Meta Pixel — initialized exactly ONCE per page load.
// The whole block is guarded by `__metaPixelInit` so that if this module is
// ever evaluated more than once (React StrictMode double-invoke, HMR, or a
// re-mount) we do NOT inject a second pixel script or fire a second PageView.
const _w = window as any;
if (!_w.__metaPixelInit) {
  _w.__metaPixelInit = true;
  if (!_w.fbq) {
    const fbq: any = _w.fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!_w._fbq) _w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Inject the Facebook events library only once.
    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(fbScript);
  }
  _w.fbq('init', '2473048559871614');
  _w.fbq('track', 'PageView');
}